<template>
    <v-modal-slot id="change-task-user-modal"
                  @accepted="emitTaskUserChanged">
        <template v-slot:modal-title>
            Cambiar responsable
        </template>

        <template v-slot:modal-content>
            <div class="row user-form">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label">Responsable: </label>

                        <select class="form-control" disabled v-if="users.length === 0">
                            <option selected>- No existen usuarios en la aplicación -</option>
                        </select>

                        <div class="input-group" v-else>
                            <v-select-jq aria-label="Responsable"
                                         parent-id="change-task-user-modal"
                                         placeholder="- Seleccionar -"
                                         ref="selectUsers"
                                         :options="users"
                                         :value="selected_user"
                                         @update:modelValue="selected_user = $event">
                            </v-select-jq>

                            <button class="delete-date" @click="$refs.selectUsers.removeAll();"
                                    :disabled="!selected_user  ? true : null">
                                <span class="uq-icon bi-x-lg"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:accept-button>
            Guardar
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>
    </v-modal-slot>
</template>

<script>
import VModalSlot from "../../general/VModalSlot";
import VModal from "../../general/VModal";
import VSelectJq from "../../general/VSelectJQ";
import {getUsers} from "../../../helpers/requests/RequestsUsers";

export default {
    name: "TaskChangeUserModal",
    components: {
        VSelectJq,
        VModalSlot,
        VModal
    },
    data() {
        return {
            selected_user: '',
            users: [],
        }
    },
    props: {
        user: {
            type: Number,
            required: false,
        }
    },
    async mounted() {
        this.selected_user = this.user;
        await this.loadAvailableUsers();
    },
    methods: {
        async loadAvailableUsers() {
            let users = await getUsers();

            if (!users.meta) {
                this.users = Object.values(users).map((user) => {
                    return {id: user.id, text: user.name + ' (' + user.email + ')'};
                });
            }
        },
        emitTaskUserChanged() {
            this.$emit('task-user-updated', this.selected_user);
        }
    },
}
</script>
